// eslint-disable-next-line import/prefer-default-export
export const GET_USER_ID = 'user_id';
